import { render } from "./UserPublications.vue?vue&type=template&id=a618b0c8&scoped=true"
import script from "./UserPublications.vue?vue&type=script&lang=js"
export * from "./UserPublications.vue?vue&type=script&lang=js"

import "./UserPublications.vue?vue&type=style&index=0&id=a618b0c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a618b0c8"]])

export default __exports__